import BreadCrumb from "components/Common/BreadCrumb";
import React from "react";
import { useTranslation } from "react-i18next";
import { Container } from "reactstrap";

export default function WalletSetting() {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Wallet Settings")} pageTitle={t("Settings")} />
        </Container>
      </div>
    </React.Fragment>
  );
}
